import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useCategories } from '../hooks/useCategories';
import { useRoutineSessionStore } from '../stores/routineSessionStore';

/**
 * A slim companion to RoutineSessionWidget showing what's NEXT in the running
 * routine. Reads the same runtime snapshot the timer publishes; hides on the last
 * step (no "next"). Clicking it expands the run, like the current-step pill.
 */
export function RoutineNextWidget() {
  const runtime = useRoutineSessionStore(s => s.runtime);
  const expand = useRoutineSessionStore(s => s.expand);
  const { getCategoryColor } = useCategories();

  if (!runtime || !runtime.nextLabel) return null;

  const color = runtime.nextCategory ? getCategoryColor(runtime.nextCategory) : '#94a3b8';

  return (
    <div
      className="flex w-fit max-w-full items-center gap-1.5 rounded-full border border-dashed px-2.5 py-1 cursor-pointer hover:brightness-110 transition-all"
      style={{ backgroundColor: `${color}0d`, borderColor: `${color}80` }}
      onClick={expand}
      title="Next up"
    >
      <ArrowRight className="w-3 h-3 shrink-0 text-muted-foreground" />
      <span className="text-[11px] uppercase tracking-wide text-muted-foreground">Next</span>
      <span className="h-2 w-2 rounded-full shrink-0" style={{ backgroundColor: color }} />
      <span className="text-xs font-medium text-foreground truncate max-w-[96px]">
        {runtime.nextLabel}
      </span>
    </div>
  );
}
